import React, { useEffect, useRef, useState } from "react";
import cn from "classnames";
import style from "./style.module.scss";
import OrdersLocationDropdown from "./OrdersLocationDropdown";
import { useClickOutside } from "../../../hooks/useClickOutside";
import { t } from "i18next";

const OrdersLocationInfo = ({
  isSender = false,
  isEditable = false,
  isRecipientLatLng = false,
  forceOpenDropdown = false,
  forceOpenDropdownCount = 0,
  address = "",
  onChangeAddress,
  onChangeResipient,
  countrySelected,
  citySelected,
  onRecipientPhone,
  onChangeCity,
  onChangeCountry,
  companyName = "",
  labelText = "",
  errorText = "",
  phoneNumber,
  countries = [],
  detect,
  onCoordinates,
  onAddressId,
  onRecipientEmail,
}) => {
  const [displayModal, changeDisplayModal] = useState(false);
  const infoRef = useRef(null);
  const iconColor = isEditable ? "" : "-color";

  if (isEditable) {
    useClickOutside(infoRef, () => changeDisplayModal(false));
  }

  const clickHandle = (obj) => {
    if (onChangeAddress) {
      onChangeAddress(obj.fullAddress);
    }
    if (onChangeResipient) {
      onChangeResipient(obj?.name);
    }
    if (onRecipientPhone) {
      onRecipientPhone(obj?.phoneNumber);
    }
    if (onCoordinates) {
      onCoordinates(obj?.latLng);
    }
    if (onAddressId) {
      onAddressId(obj?.id);
    }
    if (onRecipientEmail) {
      onRecipientEmail(obj?.email);
    }
    changeDisplayModal(false);
    if (detect) detect();
  };

  return (
    <>
      <div
        ref={infoRef}
        className={cn(style.wrapper, { [style.errorState]: errorText })}
        onClick={() => {
          isEditable ? changeDisplayModal(!displayModal) : null;
        }}
      >
        <label className={cn(style.labelInp, { [style.labelError]: errorText })}>{labelText}</label>
        <img src={"/icons/" + (isSender ? "sender" : "location") + iconColor + ".svg"} alt="icon" />
        <div className={style.content}>
          {isEditable && !address ? (
            <div>{t("carsCreatePage.vehicleType.placeholder")} {isSender ? t("addressOrder.sender") : t("addressOrder.recipient")}</div>
          ) : (
            <>
              {companyName && <h4>{companyName}</h4>}
              <p>{address}</p>
            </>
          )}
        </div>
        {displayModal && (
          <OrdersLocationDropdown
            onClose={() => changeDisplayModal(false)}
            isSender={isSender}
            countries={countries}
            clickHandle={clickHandle}
            countrySelected={countrySelected}
            citySelected={citySelected}
            onChangeCountry={onChangeCountry}
            onChangeCity={onChangeCity}
          />
        )}
      </div>
      {errorText && <div className={style.errorText}>{errorText}</div>}
    </>
  );
};

export default OrdersLocationInfo;
